/**
 * Effektiv turneringsstatus, härledd ur status + klockan.
 *
 * Databasens status flyttas fram av live-scoring-workern varje minut
 * (open → locked vid lock_time, locked → live vid första tee). Men UI:t får
 * inte hänga på att workern hunnit köra — Wyndham 2026 stod kvar på open
 * efter inlämningsstoppet och stryktipset såg öppet ut fast databasen
 * avvisade varje försök att spara.
 *
 * Härledningen flyttar bara framåt, aldrig bakåt, och speglar exakt samma
 * villkor som RLS-funktionerna picks_open() och teams_revealed() går på.
 */
export interface StatusTimes {
  status: string
  lock_time: string
  starts_at: string
}

export function effectiveStatus(t: StatusTimes, now: Date = new Date()): string {
  const ms = now.getTime()
  if (t.status === 'open' && ms >= new Date(t.starts_at).getTime()) return 'live'
  if (t.status === 'locked' && ms >= new Date(t.starts_at).getTime()) return 'live'
  if (t.status === 'open' && ms >= new Date(t.lock_time).getTime()) return 'locked'
  return t.status
}
